import { CmsPage } from 'src/types/cms/cmsCommonTypes';
import { CmsInfoPageFields } from 'src/types/cms/cmsPageTypes';

const CMSManager = {
  inhouseCms: {
    getInfoAndRulesData: (data: CmsPage<CmsInfoPageFields>[]) => {
      return data?.map((m) => {
        return {
          title: m.content?.pageFields?.title ?? '',
          content: m.content?.pageFields?.description ?? '',
          name: m.content?.pageFields?.name ?? '',
          slug: m.slug ?? '',
          meta: m.content?.meta ?? '',
        };
      });
    },
  },
};
export { CMSManager };
